import { RoleResources } from '..'

import expenses from './expenses'
import income from './income'

export const treasurer: RoleResources = {
  treasurer_expenses: expenses,
  treasurer_income: income,
}
